























































































































































































import {Vue, Component, Watch} from 'vue-property-decorator';

import PageTitle from '@/components/common/PageTitle.vue';
import MallsTab from '@/components/common/MallsTab.vue';
import TuiTree from './TuiTree.vue';
import editor from '@/components/common/summernote/Index.vue';
import {Mall, GetMailTemplatesCustomGroupsRequest, GetMallsDataRequest} from 'supporter';
import {State, namespace} from 'vuex-class';
const mallModule = namespace('mall');
@Component({
  components: {
    PageTitle,
    MallsTab,
    TuiTree,
    editor
  }
})
export default class TemplateConfig extends Vue {
  @mallModule.Action('fetchMalls') fetchMalls!: () => Promise<any>;
  @State('malls', {namespace: 'mall'})
  private malls!: Mall[];
  private mallNo: number = 0;
  @State private onGnb!: boolean;
  private theData: any[] = [];
  private editorData: string = '';
  private selectNum: number = 1;
  private theFinalContent: string = '';
  private hasUnsavedChanges: boolean = false;
  private isUpOrDown: boolean = false;
  private emailUsed: boolean = false;
  private selectParentForm = {
    usable: true,
    groupNo: 0,
    name: ''
  };
  private selectChildForm = {
    usable: true,
    templateNo: '',
    displayOrder: '',
    name: '',
    title: '',
    content: '',
    parentData: {
      groupNo: 0
    }
  };
  private editorOnChange({html, text}: {html: string; text: string}): void {
    this.theFinalContent = html;
  }
  private onClickUpBtn() {
    if (this.hasUnsavedChanges) {
      alert(this.$t('MAIL_TEMP_CONFIG_SAVE_BEFORE_MOVE_GROUP_AND_TEMPLATE'));
      return false;
    }
    const tree = (this.$refs.theTree as any).tree;
    const targetId = tree.getSelectedNodeId();
    const isGroup = tree.getDepth(targetId) === 1;
    if (isGroup) {
      const group = tree.getNodeData(targetId);
      if (group.displayOrder > 0) {
        let obj = {
          pathParams: {
            groupNo: group.groupNo + ''
          },
          params: {
            mallNo: Number(this.$route.query.mallNo)
          },
          data: {
            newOrder: group.displayOrder - 1,
            currentOrder: group.displayOrder
          }
        };
        this.$api.putMailTemplatesCustomGroupsOrder(obj).then(() => {
          this.initData();
          this.isUpOrDown = true;
        });
      }
    } else {
      const parentId = tree.getParentId(targetId);
      const template = tree.getNodeData(targetId);
      const parentData = tree.getNodeData(parentId);
      if (template.displayOrder > 0) {
        let obj = {
          pathParams: {
            groupNo: parentData.groupNo + '',
            templateNo: template.templateNo + ''
          },
          params: {
            mallNo: Number(this.$route.query.mallNo)
          },
          data: {
            newOrder: template.displayOrder - 1,
            currentOrder: template.displayOrder
          }
        };
        this.$api.putMailTemplatesCustomGroupsTemplatesOrder(obj).then(() => {
          this.initData();
          this.isUpOrDown = true;
        });
      }
    }
  }
  private onClickDownBtn() {
    if (this.hasUnsavedChanges) {
      alert(this.$t('MAIL_TEMP_CONFIG_SAVE_BEFORE_MOVE_GROUP_AND_TEMPLATE'));
      return false;
    }
    const tree = (this.$refs.theTree as any).tree;
    const targetId = tree.getSelectedNodeId();
    const isGroup = tree.getDepth(targetId) === 1;
    if (isGroup) {
      const group = tree.getNodeData(targetId);
      if (group.displayOrder < this.theData.length - 1) {
        let obj = {
          pathParams: {
            groupNo: group.groupNo + ''
          },
          params: {
            mallNo: Number(this.$route.query.mallNo)
          },
          data: {
            newOrder: group.displayOrder + 1,
            currentOrder: group.displayOrder
          }
        };
        this.$api.putMailTemplatesCustomGroupsOrder(obj).then(() => {
          this.initData();
          this.isUpOrDown = true;
        });
      }
    } else {
      const parentId = tree.getParentId(targetId);
      const template = tree.getNodeData(targetId);
      const parentData = tree.getNodeData(parentId);
      if (template.displayOrder < parentData.templates.length - 1) {
        let obj = {
          pathParams: {
            groupNo: parentData.groupNo + '',
            templateNo: template.templateNo + ''
          },
          params: {
            mallNo: Number(this.$route.query.mallNo)
          },
          data: {
            newOrder: template.displayOrder + 1,
            currentOrder: template.displayOrder
          }
        };
        this.$api.putMailTemplatesCustomGroupsTemplatesOrder(obj).then(() => {
          this.initData();
          this.isUpOrDown = true;
        });
      }
    }
  }
  private addGroupTree(): any {
    if (this.hasUnsavedChanges) {
      alert(this.$t('MAIL_TEMP_CONFIG_SAVE_BEFORE_MOVE_GROUP_AND_TEMPLATE'));
      return false;
    }
    let obj = {
      text: '템플릿 폴더명 입력',
      usable: true,
      name: '',
      displayOrder: 99999
    };
    this.theData.length += 1;
    (this.$refs.theTree as any).addTree(obj);
    this.hasUnsavedChanges = true;
  }
  private addTemplateTree(): any {
    if (this.hasUnsavedChanges) {
      alert(this.$t('MAIL_TEMP_CONFIG_SAVE_BEFORE_MOVE_GROUP_AND_TEMPLATE'));
      return false;
    }
    const tree = (this.$refs.theTree as any).tree;
    const selectedNodeId = tree.getSelectedNodeId();
    let targetId;
    if (tree.getDepth(selectedNodeId) === 1) {
      targetId = selectedNodeId;
      const group = tree.getNodeData(targetId);

      if (typeof group.groupNo === 'undefined') {
        alert(this.$t('MAIL_TEMP_CONFIG_REGISTER_GROUP_BEFORE_ADD_TEMPLATE'));

        return;
      }
    } else {
      targetId = tree.getParentId(selectedNodeId);
    }
    let obj = {
      usable: true,
      templateNo: 0,
      name: '',
      title: '',
      content: '',
      text: '템플릿명 입력',
      displayOrder: 99999
    };
    (this.$refs.theTree as any).addTree(obj, targetId);
    this.hasUnsavedChanges = true;
  }
  private onClickRemoveBtn() {
    const tree = (this.$refs.theTree as any).tree;
    const selectedNodeId = tree.getSelectedNodeId();
    const isGroup = tree.getDepth(selectedNodeId) === 1;
    const mallNo = Number(this.$route.query.mallNo);

    if (isGroup) {
      let msg;
      if (tree.getChildIds(selectedNodeId).length !== 0) {
        msg = 'MAIL_TEMP_CONFIG_CONFIRM_DELETE_GROUP_TEMPLATE';
      } else {
        msg = 'MAIL_TEMP_CONFIG_CONFIRM_DELETE_GROUP';
      }

      if (confirm(this.$t(msg) as string)) {
        const groupNo = tree.getNodeData(selectedNodeId).groupNo;

        if (groupNo >= 0) {
          let obj = {
            pathParams: {
              groupNo: groupNo + ''
            },
            params: {
              mallNo: mallNo
            }
          };
          this.$api.deleteMailTemplatesCustomGroups(obj).then(() => {
            if (Array.isArray(selectedNodeId)) {
              tree.remove(selectedNodeId[0]);
            } else {
              tree.remove(selectedNodeId);
            }
            this.hasUnsavedChanges = false;
            tree.select(tree.model.rootNode._childIds[0]);
            if (tree.model.rootNode._childIds.length === 0) {
              this.theData = [];
            }
          });
        } else {
          if (Array.isArray(selectedNodeId)) {
            tree.remove(selectedNodeId[0]);
          } else {
            tree.remove(selectedNodeId);
          }
          this.hasUnsavedChanges = false;
          tree.select(tree.model.rootNode._childIds[0]);
          if (tree.model.rootNode._childIds.length === 0) {
            this.theData = [];
          }
        }
      }
    } else {
      const msg = 'MAIL_TEMP_CONFIG_CONFIRM_DELETE_TEMPLATE';

      if (confirm(this.$t(msg) as string)) {
        const templateNo = tree.getNodeData(selectedNodeId).templateNo;

        if (templateNo > 0) {
          let obj = {
            pathParams: {
              groupNo: this.selectChildForm.parentData.groupNo + '',
              templateNo: templateNo + ''
            },
            params: {
              mallNo: mallNo
            }
          };
          this.$api.deleteMailTemplatesCustomGroupsTemplates(obj).then(() => {
            if (Array.isArray(selectedNodeId)) {
              tree.remove(selectedNodeId[0]);
            } else {
              tree.remove(selectedNodeId);
            }
            this.hasUnsavedChanges = false;
            tree.select(tree.model.rootNode._childIds[0]);
            if (tree.model.rootNode._childIds.length === 0) {
              this.theData = [];
            }
          });
        } else {
          if (Array.isArray(selectedNodeId)) {
            tree.remove(selectedNodeId[0]);
          } else {
            tree.remove(selectedNodeId);
          }
          this.hasUnsavedChanges = false;
          tree.select(tree.model.rootNode._childIds[0]);
          if (tree.model.rootNode._childIds.length === 0) {
            this.theData = [];
          }
        }
      }
    }
  }
  private onClickSaveBtn() {
    const tree = (this.$refs.theTree as any).tree;
    const isTemplate = tree.getDepth(tree.getSelectedNodeId()) === 2;

    if (isTemplate) {
      this.saveTemplate();
    } else {
      this.saveGroup();
    }
  }
  private onClickCancelBtn() {
    window.location.reload();
  }
  private saveGroup() {
    if (this.selectParentForm.name === '') {
      alert(this.$t('MAIL_TEMP_CONFIG_ENTER_GROUP_NAME'));
      return;
    }
    if (confirm(this.$t('MAIL_TEMP_CONFIG_CONFIRM_SAVE') as string)) {
      this.saveGroupToAjax();
    }
  }
  private saveTemplate() {
    if (this.selectChildForm.name === '') {
      alert(this.$t('MAIL_TEMP_CONFIG_ENTER_TEMPLATE_NAME'));
      return;
    }
    if (this.selectChildForm.title === '') {
      alert(this.$t('MAIL_TEMP_CONFIG_ENTER_TEMPLATE_TITLE'));
      return;
    }
    if (this.theFinalContent === '') {
      alert(this.$t('MAIL_TEMP_CONFIG_ENTER_TEMPLATE_CONTENT'));
      return;
    }
    if (confirm(this.$t('MAIL_TEMP_CONFIG_CONFIRM_SAVE') as string)) {
      this.saveTemplateToAjax();
    }
  }
  private saveGroupToAjax() {
    let obj = {
      pathParams: {
        groupNo: null
      },
      params: {
        mallNo: Number(this.$route.query.mallNo)
      },
      data: {
        groupName: this.selectParentForm.name,
        groupUsed: this.selectParentForm.usable
      }
    };
    if (this.selectParentForm.groupNo) {
      obj.pathParams.groupNo = (this.selectParentForm.groupNo + '') as any;
      this.$api.putMailTemplatesCustomGroups(obj).then(() => {
        this.hasUnsavedChanges = false;
        alert('저장되었습니다.');
        this.initData();
      });
    } else {
      this.$api.postMailTemplatesCustomGroups(obj).then(() => {
        this.hasUnsavedChanges = false;
        alert('저장되었습니다.');
        this.initData();
      });
    }
  }
  private saveTemplateToAjax() {
    let obj: any = {
      pathParams: {
        groupNo: this.selectChildForm.parentData.groupNo,
        templateNo: null
      },
      params: {
        mallNo: Number(this.$route.query.mallNo)
      },
      data: {
        templateUsed: this.selectChildForm.usable,
        templateName: this.selectChildForm.name,
        title: this.selectChildForm.title,
        content: this.theFinalContent
      }
    };
    if (this.selectChildForm.templateNo) {
      obj.pathParams.templateNo = (this.selectChildForm.templateNo + '') as any;
      this.$api.putMailTemplatesCustomGroupsTemplates(obj).then(() => {
        this.hasUnsavedChanges = false;
        alert('저장되었습니다.');
        this.initData();
      });
    } else {
      this.$api.postMailTemplatesCustomGroupsTemplates(obj).then(() => {
        this.hasUnsavedChanges = false;
        alert('저장되었습니다.');
        this.initData();
      });
    }
  }
  private tuiTreeSelect(template: any): void {
    this.selectNum = template.theIndex;
    if (this.selectNum === 1) {
      this.selectParentForm = template.theObj;
    } else {
      if (this.selectChildForm.templateNo === template.theObj.templateNo) {
        return;
      }
      this.selectChildForm = template.theObj;
      this.selectChildForm.parentData = template.theParentData;
      let $summernote: any = $('#summernote');
      $summernote.summernote('reset');
      $summernote.summernote('code', '');
    }
  }
  private initTree(): void {
    const tree = (this.$refs.theTree as any).tree;
    tree &&
      tree.on('beforeSelect', (e: any) => {
        if (this.hasUnsavedChanges !== false && (e.nodeId === tree.getSelectedNodeId() || (tree.getSelectedNodeId() !== null && e.nodeId === tree.getSelectedNodeId()[0]))) {
          return false;
        }

        if (this.hasUnsavedChanges) {
          alert(this.$t('MAIL_TEMP_CONFIG_SAVE_BEFORE_MOVE_GROUP_AND_TEMPLATE'));

          return false;
        }

        return true;
      });
    // tree &&
    //   tree.sort((nodeA: any, nodeB: any) => {
    //     var aValue = nodeA.getData('displayOrder'),
    //       bValue = nodeB.getData('displayOrder');
    //     return aValue > bValue ? 1 : -1;
    //   });
    if (tree && this.$route.query.selectId) {
      tree.open(this.$route.query.selectId, true);
      tree.select(this.$route.query.selectId);
      this.$router.push({
        path: '/mail/template-config',
        query: {
          mallNo: this.$route.query.mallNo
        }
      });
    }
  }
  private dataFormat(data: any[]): any[] {
    let newData = data
      .map(item => {
        Vue.set(item, 'text', item.name);
        if (item.templates) {
          Vue.set(item, 'children', item.templates);
          if (item.templates.length > 0) {
            this.dataFormat(item.children);
          }
        }
        return item;
      })
      .sort((itemA: any, itemB: any) => {
        return itemA.displayOrder > itemB.displayOrder ? 1 : -1;
      });
    return newData;
  }  
  private initData(): void {
    let theObj: GetMailTemplatesCustomGroupsRequest = {
      params: {
        mallNo: Number(this.$route.query.mallNo)
      }
    };
    this.$api.getMailTemplatesCustomGroups(theObj).then((res) => {
      this.theData = [];
      this.theData = this.dataFormat(res.data);
    });
  }
  private async configurations() {
    const configRequest: GetMallsDataRequest = {
      params: {
        mallNo: this.mallNo
      }
    };

    await this.$api
      .getNotificationsConfigurations(configRequest)
      .then((res) => {
        this.emailUsed = res.data.emailUsed;
      })
      .catch((e: any) => {
        if (e.data.code === 'MC0002') {
          this.emailUsed = false;
        }
      });
    if (!this.emailUsed) {
      window.location.assign(`/mail/usage-list?mallNo=${this.mallNo}&tabNo=5`);
    }
  }
  @Watch('$route.query.mallNo', {immediate: false, deep: false})
  async onMallChanged() {
    if (this.$route.query.mallNo) {
      this.mallNo = Number(this.$route.query.mallNo);
    } else {
      this.mallNo = this.malls[0].mallNo;
    }
    this.toFirstPage();
    // await this.configurations();

  }
  private toFirstPage() {
    // console.log(this.$route.query.mallNo)
    // window.location.reload();
    let url = `/mail/dispatch?mallNo=${this.mallNo}&tabNo=1`;
    window.location.assign(url);
  }
  private async mounted() {
    await this.fetchMalls();
    if (this.$route.query.mallNo) {
      this.mallNo = Number(this.$route.query.mallNo);
    } else {
      this.mallNo = this.malls[0].mallNo;
    }    
    this.initData();
    // #addTemplateBtn 左右两端多空格 撑大容器 不能一行显示，去除左右空格恢复正常
    $('#addTemplateBtn').html((this.$t('MAIL_TEMP_CONFIG_ADD_TEMP_BTN') as string).replace(/(^\s*)|(\s*$)/g, ''));
    await this.configurations();
  }
  private updated(): void {
    this.$nextTick(() => {
      this.initTree();
    });
  }
}
